import { addCoreDataDictionaryViewsSyncSlice } from './add';
import { combineReducers } from 'redux';
import { deleteCoreDataDictionaryViewsAsyncSlice } from './delete';
import { getCoreDataDictionaryViewsAsyncSlice } from './get';
import { patchCoreDataDictionaryViewsAsyncSlice } from './patch';
import { postCoreDataDictionaryViewAsyncSlice } from './post';
import { removeCoreDataDictionaryViewSyncSlice } from './remove';
import { updateCoreDataDictionaryViewsSyncSlice } from './update';

import { combineAllWatchers, joinCollectionReducers } from '@sonar-software/xuder';
import { coreDataDictionaryViewReferencesReducers, coreDataDictionaryViewReferencesWatchers } from './references';
import { coreDataDictionaryViewsSharedKeyReducers, coreDataDictionaryViewsSharedKeyWatchers } from './shared-key';

export const coreDataDictionaryViewsReducers = combineReducers({
	delete: deleteCoreDataDictionaryViewsAsyncSlice.asyncReducers,
	get: joinCollectionReducers(
		[
			getCoreDataDictionaryViewsAsyncSlice.asyncReducers,
			addCoreDataDictionaryViewsSyncSlice.syncReducer,
			removeCoreDataDictionaryViewSyncSlice.syncReducer,
			updateCoreDataDictionaryViewsSyncSlice.syncReducer
		],
		getCoreDataDictionaryViewsAsyncSlice.asyncState
	),
	patch: patchCoreDataDictionaryViewsAsyncSlice.asyncReducers,
	post: postCoreDataDictionaryViewAsyncSlice.asyncReducers,
	references: coreDataDictionaryViewReferencesReducers,
	sharedKey: coreDataDictionaryViewsSharedKeyReducers
});

export const coreDataDictionaryViewsWatchers = combineAllWatchers([
	deleteCoreDataDictionaryViewsAsyncSlice.asyncWatchers,
	getCoreDataDictionaryViewsAsyncSlice.asyncWatchers,
	patchCoreDataDictionaryViewsAsyncSlice.asyncWatchers,
	postCoreDataDictionaryViewAsyncSlice.asyncWatchers,
	coreDataDictionaryViewReferencesWatchers,
	coreDataDictionaryViewsSharedKeyWatchers
]);
